import { FactoryProvider, InjectionToken } from '@angular/core';

export const CMPS_APP_CONFIG_CONTAINER: { value: AppConfig } = { value: {} };

export interface AppConfig {
    DEFAULT_LANGUAGE?: string;
    OAUTH?: {
        AUTHORIZATION_ENDPOINT: string;
        CLIENT_ID: string;
        SCOPES: string[];
        REDIRECT_URI: string;
    };
    API_ENDPOINTS?: {
        NOTIFICATION: string;
        USER: string;
        TRANSLATION: string;
        USER_PROFILE: string;
        INSIGHT: string;
        COACHING: string;
        REPORT: string;
        SCORECARD: string;
        TEAMS_CALL: string;
        EVALUATION: string;
        DATA_PULL: string;
        OBJECT_STORE: string;
        UI_AGENT: string;
        LOCAL_CALL: string;
    };
    CLIENT_BACKGROUND?: string;
    CLIENT_LOGO?: string;
    CLIENT_LOGO_RIGHT?: string; // TODO revise
}

// eslint-disable-next-line @typescript-eslint/promise-function-async
export function load(): Promise<void> {
    const req = new XMLHttpRequest();
    return new Promise<void>((resolve) => {
        req.addEventListener('load', () => {
            CMPS_APP_CONFIG_CONTAINER.value = JSON.parse(req.response);
            console.log(CMPS_APP_CONFIG_CONTAINER.value);
            resolve();
        });
        req.open(
            'GET',
            `${document
                .querySelector('base')
                .getAttribute('href')}app.config.json?t=${Date.now()}`,
        );
        req.send();
    });
}

export const CMPS_APP_CONFIG = new InjectionToken<AppConfig>('CMPS_APP_CONFIG');

export function AppConfigFactory(): AppConfig {
    return CMPS_APP_CONFIG_CONTAINER.value;
}

export const AppConfigProvider: FactoryProvider = {
    provide: CMPS_APP_CONFIG,
    useFactory: AppConfigFactory,
};
